import React from "react";
import { ThemedText } from "@components/ThemedText";
import { V3Button } from "@components/v3/primitives";
import { Container, ButtonGroup, ReverseWrapper } from "./styled";

type Props = {
  Image?: () => JSX.Element;
  heading: string;
  subHeading: string;
  leftButtonText?: string;
  rightButtonText?: string;
  onClickLeft?: () => void;
  onClickRight?: () => void;
};

const EmptyState: React.FC<Props> = ({
  Image,
  heading,
  subHeading,
  leftButtonText,
  onClickLeft,
  rightButtonText,
  onClickRight,
}) => (
  <Container data-testid="payments-empty-state">
    {Image && <Image />}
    <ThemedText
      align="center"
      type="T32"
      color="SLATE900"
      fontFamily="archiasemibold"
    >
      {heading}
    </ThemedText>
    <ReverseWrapper>
      <ThemedText align="center" type="S18" color="SLATE700">
        {subHeading}
      </ThemedText>
      <ButtonGroup
        twoButtons={Boolean(
          onClickLeft && leftButtonText && onClickRight && rightButtonText
        )}
      >
        {onClickLeft && leftButtonText && (
          <V3Button testID="left-button" onClick={onClickLeft}>
            {leftButtonText}
          </V3Button>
        )}
        {onClickRight && rightButtonText && (
          <V3Button
            testID="right-button"
            variant="outline"
            onClick={onClickRight}
          >
            {rightButtonText}
          </V3Button>
        )}
      </ButtonGroup>
    </ReverseWrapper>
  </Container>
);

export default EmptyState;
